export const tr = {
    cancel: 'İptal',
    create: 'Oluştur',
    'new-creative': 'Yeni kreatif'
};
